export const KAABA_LATITUDE = 21.4225;
export const KAABA_LONGITUDE = 39.8262;
const EARTH_RADIUS_KM = 6371.0088;

const toRad = (value: number) => (value * Math.PI) / 180;
const toDeg = (value: number) => (value * 180) / Math.PI;

export function normalizeDegrees(value: number): number {
  return ((value % 360) + 360) % 360;
}

export function shortestSignedAngle(value: number): number {
  return normalizeDegrees(value + 180) - 180;
}

export function qiblaBearing(latitude: number, longitude: number): number {
  const fromLatitude = toRad(latitude);
  const toLatitude = toRad(KAABA_LATITUDE);
  const longitudeDelta = toRad(KAABA_LONGITUDE - longitude);
  const y = Math.sin(longitudeDelta) * Math.cos(toLatitude);
  const x =
    Math.cos(fromLatitude) * Math.sin(toLatitude) -
    Math.sin(fromLatitude) * Math.cos(toLatitude) * Math.cos(longitudeDelta);
  return normalizeDegrees(toDeg(Math.atan2(y, x)));
}

export function qiblaDistanceKm(latitude: number, longitude: number): number {
  const latDelta = toRad(KAABA_LATITUDE - latitude);
  const lonDelta = toRad(KAABA_LONGITUDE - longitude);
  const fromLatitude = toRad(latitude);
  const toLatitude = toRad(KAABA_LATITUDE);
  const a =
    Math.sin(latDelta / 2) ** 2 +
    Math.cos(fromLatitude) * Math.cos(toLatitude) * Math.sin(lonDelta / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function relativeDirection(qibla: number, heading: number): number {
  return shortestSignedAngle(qibla - heading);
}

export function turnDirection(relative: number): 'left' | 'right' | 'aligned' {
  const normalized = shortestSignedAngle(relative);
  if (Math.abs(normalized) <= 3) return 'aligned';
  return normalized > 0 ? 'right' : 'left';
}

export function cardinalDirection(bearing: number): string {
  const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  return directions[Math.floor((normalizeDegrees(bearing) + 22.5) / 45) % directions.length] ?? 'N';
}
